import { defineMessages } from 'react-intl';

export const powerEfficiencyFlagMessages = defineMessages<string>({
  ariaLabel: {
    id: 'powerEfficiencyflag.aria.label',
    defaultMessage: 'Energieeffizienz “{energyClass}“',
  },
});
